"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HybridSearchOptionsSchema = exports.LexicalSearchOptionsSchema = exports.SearchOperatorSchema = exports.SearchOperator = exports.LexicalQueryTypeSchema = exports.LexicalQueryType = void 0;
const zod_1 = require("zod");
var LexicalQueryType;
(function (LexicalQueryType) {
    LexicalQueryType["Match"] = "match";
    LexicalQueryType["Phrase"] = "phrase";
    LexicalQueryType["SimpleQueryString"] = "simple_query_string";
})(LexicalQueryType || (exports.LexicalQueryType = LexicalQueryType = {}));
exports.LexicalQueryTypeSchema = zod_1.z.nativeEnum(LexicalQueryType);
var SearchOperator;
(function (SearchOperator) {
    SearchOperator["Or"] = "or";
    SearchOperator["And"] = "and";
})(SearchOperator || (exports.SearchOperator = SearchOperator = {}));
exports.SearchOperatorSchema = zod_1.z.nativeEnum(SearchOperator);
const MatchQueryOptionsSchema = zod_1.z.object({
    type: zod_1.z.literal(LexicalQueryType.Match),
    operator: exports.SearchOperatorSchema.optional(),
    fuzziness: zod_1.z.union([zod_1.z.literal('AUTO'), zod_1.z.literal(0), zod_1.z.literal(1), zod_1.z.literal(2), zod_1.z.literal(false)]).optional(),
    minimumShouldMatch: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]).optional(),
    analyzer: zod_1.z.string().optional(),
});
const MatchPhraseQueryOptionsSchema = zod_1.z.object({
    type: zod_1.z.literal(LexicalQueryType.Phrase),
    slop: zod_1.z.number().optional(),
    analyzer: zod_1.z.string().optional(),
});
const SimpleQueryStringOptionsSchema = zod_1.z.object({
    type: zod_1.z.literal(LexicalQueryType.SimpleQueryString),
    defaultOperator: exports.SearchOperatorSchema.optional(),
    flags: zod_1.z.string().optional(),
    analyzer: zod_1.z.string().optional(),
    minimumShouldMatch: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]).optional(),
});
exports.LexicalSearchOptionsSchema = zod_1.z.discriminatedUnion('type', [
    MatchQueryOptionsSchema,
    MatchPhraseQueryOptionsSchema,
    SimpleQueryStringOptionsSchema,
]);
exports.HybridSearchOptionsSchema = zod_1.z.object({
    semanticWeight: zod_1.z.number().min(0).max(1).optional(),
    lexicalWeight: zod_1.z.number().min(0).max(1).optional(),
    minScore: zod_1.z.number().optional(),
    lexicalOptions: exports.LexicalSearchOptionsSchema.optional(),
});
//# sourceMappingURL=search-options.js.map